import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { postApi } from "../../services/api";
import Middleware from "../Middleware/Middleware";

const SessionMiddleware = ({ children }) => {
	const { classroomId } = useParams();
	const { user } = useContext(AuthContext);
	const validateRoom = async () => {
		try {
			const res =
				user?.role === "student"
					? await postApi("/meeting/validateStudent", {
							userId: user._id,
							classroomId,
					  })
					: await postApi("/meeting/validateTeacher", {
							userId: user._id,
							classroomId,
					  });
			// if (res.success) {
			// 	toast.success("Room validated successfully!");
			// }
			console.log(res);
			return res.success;
		} catch (error) {
			console.error(error.message);
			// toast.error("Failed to validate room. Please try again.");
		}
	};

	return (
		<Middleware additionalCriteria={validateRoom}>{children}</Middleware>
	);
};

export default SessionMiddleware;
